import { useEffect, useState } from 'react';
import '../../../../assets/css/providercustomers.css';
import '../../../../assets/css/bookings.css';
import '../../../../assets/css/filter.css';
import '../../../../assets/css/tables.css';
import '../../../../assets/css/providerreviews.css';
import { useDictionary } from '../../../../utilities/hooks/UseDictionary';
import PaginationController from '../../common/pagination_controller/PaginationController';
import SimpleLoader from '../../common/SimpleLoader';
import SortOptionsSelector from '../../common/sort_options/SortOptionsSelector';
import { useHistory } from 'react-router-dom';
import { NavigatorPaths } from '../../../../assets/dictionaries/NavigatorPaths';
import ConfirmationModal from '../../common/ConfirmationModal';
import { getProviderReviews } from './networking';
import ProviderReviewsItem from './ProviderReviewsItem';
import ViewTypeSelector from '../../common/ViewTypeSelector';
import ProviderReviewsCompact from './ProviderReviewsCompact';
const ProviderReviews = () =>{
    const dictionary = useDictionary();
	const history = useHistory()
    const [providerReviews,setProviderReviews] = useState([]);
    const [pageSize, setPageSize] = useState(
		parseInt(localStorage.getItem('providerreviews_selected_page_size') ?? 10)
	);
	const [viewType, setViewType] = useState(
		parseInt(localStorage.getItem('providerreviews_selected_view_type') ?? 0)
	);
	const [selectedOption, setSelectedOption] = useState(localStorage.getItem('providerreviews_selected_sort_type') ? JSON.parse(localStorage.getItem('providerreviews_selected_sort_type')) : {value: 'created_at', direction: 'desc', label: 'Newest'});
	const [currentPage, setCurrentPage] = useState(0);
	const [dataLength, setDataLength] = useState(0);
	const [showLoader, setShowLoader] = useState(true);
	const [showDeleteDialog, setDeleteDialogVisibility] = useState(false);

    const columnsConfig = {
		[dictionary.booking]: { fixed: false, visible: true },
		[dictionary.create_date]: { fixed: true, visible: true },
		[dictionary.customer]: { fixed: false, visible: true },
		[dictionary.experience]: { fixed: false, visible: true },
		[dictionary.Slot_Start_Date]: { fixed: false, visible: true },
		[dictionary.Phrase]: { fixed: false, visible: true },
		[dictionary.rating]: { fixed: false, visible: true }
	};

	const onViewTypeChanged = (type) => {
		setViewType(type);
	};

    const getProviderReviewsAsync = async () => {
		setShowLoader(true);
		try {
			const {data} = await getProviderReviews(selectedOption,pageSize,currentPage)
			setProviderReviews(data.data);
			setDataLength(data.recordsFiltered ?? data?.recordsTotal ?? 0);
			setShowLoader(false);
		} catch (error) {
			setShowLoader(false);
			console.error('Error fetching providerReviews:', error);
		}
    }

	const onSortOptionValueChanged = (option) => {
		if(option.value !== selectedOption.value){
			setSelectedOption(option);
		}
	};

    useEffect(()=>{
		setShowLoader(true);
        getProviderReviewsAsync();
    },[pageSize, currentPage, selectedOption])

    const onProviderReviewsClicked = (item) => {
		history.push(`/${NavigatorPaths.provider_reviews.path}/${item.id}`);
    }

    const onPagingParameterChanged = (type, newParameter) => {
		if (type === 'page') {
			setCurrentPage(newParameter);
		} else if (type === 'page-size') {
			setPageSize(newParameter);
		}
	};

    return (
        <div
			className="provider-customers-container provider-review-container container-wrapper"
			style={{
				position: 'relative',
				background: 'var(--background-color)',
				paddingTop: '0'
			}}
		>
			<div className="booking-header-container provider-customers-header-container">
				<h2 className="title-main">
					{dictionary.providerReviews}
				</h2>
				<div className="flex-filler" />
				<div className='wrappper_sortoptions'>
					<SortOptionsSelector
						onValueChanged={onSortOptionValueChanged}
						name={'providerreviews'}
					/>
					<ViewTypeSelector
						onValueChanged={onViewTypeChanged}
						name={'providerreviews'}
					/>
				</div>
			</div>
			{providerReviews?.length === 0 ? (
				<div
					className="empty-provider-customers-list-wrapper d-flex-center"
					style={{ height: '80%' }}
				>
					<div className="empty-provider-customers-list-placeholder d-flex-center">
						<div className="empty-provider-reviews-image" />
						<h3
							data-testid="no-bookings-yet-header"
							className='empty-provider-customers-title'
						>
							{dictionary.empty_provider_reviews_message}
						</h3>
						<div className="text empty-provider-customers-message">
							{dictionary.empty_provider_reviews_descriptions}
						</div>
					</div>
				</div>
			) : null}
			{
				providerReviews.length > 0 && (
					<>
					{
						viewType === 0 ? (
							<div className="upiria-table-container booking-table-container">
								<div className="upiria-table-header-strip" />
								<div className="upiria-table-container-inner thin-scrollbar">
									<table
										cellSpacing="0"
										cellPadding="0"
										border="0"
										className="upiria-table-container-provider-review-table"
									>
										<thead>
										<tr>
											{
												Object.keys(columnsConfig).map(
													(col,index) => columnsConfig[col].visible && <th key={col}>{col} {index == 0 ? '#': ''}</th>
												)
											}
										</tr>
										</thead>
										<tbody>
											{providerReviews?.map((item) => (
												<ProviderReviewsItem
													key={item.id}
													onProviderReviewsClicked={onProviderReviewsClicked}
													item={item}
												/>
											))}
										</tbody>
									</table>
								</div>
							</div>
						) : (
							<div className="upiria-table-container booking-table-container">
								<div className="upiria-table-container-inner thin-scrollbar">
									<div className='reviews-grid' style={{maxHeight: 'calc(100vh - 248px)'}}>
										{providerReviews?.map((item) => (
											<ProviderReviewsCompact
												key={item.id}
												onProviderReviewsClicked={onProviderReviewsClicked}
												item={item}
											/>
										))}
									</div>
								</div>
							</div>
						)
					}
					</>
				)
			}
            <PaginationController
				name="providerreviews"
				onParameterChanged={onPagingParameterChanged}
				dataLength={dataLength}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
			/>
			{showLoader ? <SimpleLoader showLoader={showLoader} /> : null}
			{showDeleteDialog ? (
				<ConfirmationModal
					onActionFinished={getProviderCustomersAsync}
					setShowModal={setDeleteDialogVisibility}
					asyncTask={deleteCustomerAsync}
					title={dictionary.customer_deleted}
					message={dictionary.customer_delete_message}
					successMessage={dictionary.customer_deleted_success_message}
					errorMessage={dictionary.customer_problem_deleting_booking}
					action={dictionary.delete}
				/>
			) : null}
        </div>
    )
}

export default ProviderReviews;